import {
  useRegisteredComponent,
  type AgentConfigFormSectionProps,
} from '../registry/PluginComponentRegistry';

export type { AgentConfigFormSectionProps };

/**
 * Agent configuration form section component.
 *
 * This component requires host-specific infrastructure (agent type registry,
 * model support helpers, blueprints hooks, etc.) and cannot be rendered in
 * isolation. The web host must provide the real implementation via
 * `PluginComponentProvider`.
 *
 * @throws Error if the component is not registered
 */
export function AgentConfigFormSection(props: AgentConfigFormSectionProps) {
  const RegisteredComponent = useRegisteredComponent('AgentConfigFormSection');
  return <RegisteredComponent {...props} />;
}
